import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { matchPath } from 'react-router'
import { PROPOSAL_PHASE_TYPE, PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { transformSubStationOptions } from '../../lib/optionNormalizer'
import {
  fetchUser,
  fetchPrivilegedPages,
  fetchNotifications
} from '../../actions/serviceActions'
import {
  fetchProposalSubStations,
  fetchCategoryOptions,
  fetchCategoriesBySubStations,
  fetchStruDataAttrClusterOptions,
  fetchRecentlyCategoryOptions,
  fetchProposals,
  fetchProducts,
  fetchMultipleProposals,
  fetchListingModelProposals,
  createListingModelProposals,
  updateListingModelProposals,
  fetchListingInfoProposal,
  createListingInfoProposal,
  updateListingInfoProposal,
  fetchNoCacheProposals,
  createProposals,
  updateProposals,
  fetchListings,
  fetchSpecificListing,
  fetchSubStationIdByCatItemId,
  fetchBatchProposal,
  createBatchProposal,
  updateBatchProposal,
  postBatchProposal,
  fetchBrands
} from '../../actions/serviceActions/proposal'
import {
  invokeRedirect,
  setAlerts,
  createAlert,
  dismissAlert,
  dismissLastAlert,
  redirectSharedLink,
  setErrorBoundaryError
} from '../../actions'
import { unbindBeforeunload } from '../../components/Proposal/Common/BeforeUnload'
import { setI13nData } from '../../actions/common'
import { idsParser } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import {
  FRONT_END_DEFINED_ERROR_CODE as FE_ERROR_CODE
} from '../../constants/globalTypes'
import { LISTINGS_LIMIT } from '../../constants/batchProposals'

const UPDATE_SERIES = [
  PROPOSAL_TYPE.UPDATE_COPY,
  PROPOSAL_TYPE.UPDATE_VIDEO,
  PROPOSAL_TYPE.UPDATE_IMAGE,
  PROPOSAL_TYPE.UPDATE_ATTRIBUTE,
  PROPOSAL_TYPE.UPDATE_LISTING_MODEL,
  PROPOSAL_TYPE.UPDATE_LISTING
]

export default function (Comp, compProps = {}) {
  const mapStateToProps = (state, ownProps) => {
    const user = state.page.user

    let setting = _.reduce(
      _.get(user, 'profile.accessoryContracts', {}),
      (r, contract) => {
        r[`${contract}Contract`] = true
        return r
      }, {})

    setting = _.reduce(
      _.get(user, 'profile.toggles', {}),
      (r, toggle) => {
        r[`${toggle}Toggle`] = true
        return r
      },
      { ...setting }
    )

    return {
      ...compProps,
      env: state.page.env,
      user,
      setting,
      supplier: state.supplier,
      page: state.page,
      proposal: state.proposal,
      subStationOptions: transformSubStationOptions(state.proposal.subStations, state.flags),
      flags: state.flags
    }
  }

  const mapDispatchToProps = (dispatch) => {
    const actions = Object.assign({
      setI13nData
    },
    {
      invokeRedirect,
      setAlerts,
      createAlert,
      dismissAlert,
      dismissLastAlert,
      redirectSharedLink
    },
    {
      fetchProposalSubStations,
      fetchCategoryOptions,
      fetchCategoriesBySubStations,
      fetchStruDataAttrClusterOptions,
      fetchRecentlyCategoryOptions,
      fetchNoCacheProposals,
      fetchProposals,
      fetchProducts,
      fetchMultipleProposals,
      fetchListingModelProposals,
      createListingModelProposals,
      updateListingModelProposals,
      fetchListingInfoProposal,
      createListingInfoProposal,
      updateListingInfoProposal,
      createProposals,
      updateProposals,
      fetchListings,
      fetchSpecificListing,
      fetchSubStationIdByCatItemId,
      fetchBatchProposal,
      createBatchProposal,
      updateBatchProposal,
      postBatchProposal,
      fetchBrands,
      fetchNotifications
    },
    {
      redirectSCMLogin: (timeout = 3000) => {
        unbindBeforeunload()
        return dispatch(redirectSharedLink({ key: 'scmLogin', timeout }))
      },
      redirectToSharedLink: (key, timeout = 3000) => {
        unbindBeforeunload()
        return dispatch(redirectSharedLink({ key, timeout }))
      }
    })

    return {
      actions: {
        ...bindActionCreators(actions, dispatch)
      }
    }
  }

  const compPreFetcher = Comp.preFetcher

  // Overrides default preFetcher in app.server.js
  Comp.preFetcher = ({ store, req, res }) => {
    const tasks = []
    // fetch user profile with supplier profile
    tasks.push(store.dispatch(fetchUser({ fields: '-profile' })))
    // fetch navigation privileged pages
    tasks.push(store.dispatch(fetchPrivilegedPages()))
    if (compPreFetcher) {
      tasks.push(compPreFetcher({ store, req, res }))
    }
    return Promise.all(tasks)
  }

  const compFetchData = Comp.fetchData

  Comp.fetchData = async ({ store, req, res, match }) => {
    const proposalType = compProps.proposalType
    // update 系列頁面如果不是檢視頁面且帶有 id 代表使用者可能想要修改已離開修改過的提案頁面
    // 流程中不允許修改過提案頁面離開後又返回修改，因此導向檢視頁
    const isUpdateSeries = _.includes(UPDATE_SERIES, proposalType)
    const matchedRoute = matchPath(req.path, '/proposal/:feature/:phase')
    const matchedBatchRoute = matchPath(req.path, '/proposal/batch/:feature/:phase')
    const matchedBatchNoPhaseRoute = matchPath(req.path, '/proposal/batch/:feature')
    const matchedBatchUploadRoute = matchPath(req.path, '/batchUpload/:feature/:phase')
    const matchedObj = (
      matchedBatchRoute ||
      matchedBatchNoPhaseRoute ||
      matchedRoute ||
      matchedBatchUploadRoute
    )
    const feature = _.get(matchedObj, 'params.feature')
    const phase = _.get(matchedObj, 'params.phase')
    const isBatchQueryRoute = !_.isEmpty(matchedBatchNoPhaseRoute) && feature === 'query'
    const isBatchRoute = !_.isEmpty(matchedBatchRoute) || isBatchQueryRoute
    const isBatchUploadRoute = !_.isEmpty(matchedBatchUploadRoute)
    let pathPrefix = '/proposal'
    if (isBatchRoute) {
      pathPrefix = '/proposal/batch'
    }
    if (isBatchUploadRoute) {
      pathPrefix = '/batchUpload'
    }
    const batchId = _.get(req, 'query.batchId')
    let queryStringKey = 'id'
    if (isBatchRoute) {
      queryStringKey = _.isEmpty(batchId) ? 'ids' : 'batchId'
    }
    const targetId = _.get(req, `query.${queryStringKey}`, '')
    if (isBatchQueryRoute) {
      return Promise.resolve()
    }

    if (isBatchRoute) {
      const isOverview = (phase === PROPOSAL_PHASE_TYPE.OVERVIEW)
      // 過濾掉 `,,` 空白 id 的情況
      const ids = _.compact(
        isOverview
          // 檢視頁用，批次修改含有預約回檔為批次編號、否則為提案編號
          ? idsParser(targetId)
          // 修改頁用賣場編號
          : idsParser(_.get(req, 'query.listingIds', ''))
      )
      const countIds = _.size(ids)
      // FIXME: 未來所有批次都改成上限為 200 時，即可移除 isLimit200 判斷, 並將 LISTINGS_LIMIT 改為 200
      const isLimit200 = [
        PROPOSAL_TYPE.UPDATE_VIDEO,
        PROPOSAL_TYPE.UPDATE_COPY,
        PROPOSAL_TYPE.UPDATE_ATTRIBUTE,
        PROPOSAL_TYPE.UPDATE_IMAGE
      ].includes(feature) && countIds <= 200

      let errorCode
      switch (true) {
        // query string 沒有查到指定欄位
        case (countIds === 0):
          // 確認頁、完成頁重新整理會帶著 ids，屬於正常操作
          if (!isOverview && !_.isEmpty(targetId)) {
            break
          }
          errorCode = isOverview
            ? FE_ERROR_CODE.FE_PROPOSAL_NOT_FOUND
            : FE_ERROR_CODE.FE_LISTING_NOT_FOUND
          break
        // query string 查到指定欄位編號數量超過上限
        // FIXME: 未來所有批次都改成上限為 200 時，即可移除 isLimit200 判斷, 並將 LISTINGS_LIMIT 改為 200
        case (countIds > LISTINGS_LIMIT && !isLimit200):
          errorCode = isOverview
            ? FE_ERROR_CODE.FE_BATCH_PROPOSALS_OVER_LIMIT
            : FE_ERROR_CODE.FE_BATCH_LISTINGS_OVER_LIMIT
          break
        default:
          break
      }
      // 有 error code 寫入預設 redux state
      // 初始化 component 時 withCommonPageErrorBoundary 會檢查
      // 有 errorBoundaryError 直接顯示錯誤頁
      if (!_.isUndefined(errorCode)) {
        const tasks = [
          store.dispatch(setErrorBoundaryError({ code: errorCode, ids }))
        ]
        return Promise.all(tasks)
      }
    } else {
      const listingId = idsParser(_.get(req, 'query.listingId', ''))
      // 修改賣場資訊 URL 處理
      if (proposalType === PROPOSAL_TYPE.UPDATE_LISTING) {
        // 帶 listingId 但是沒有 compose path 時幫他導向 /compose
        if (_.isEmpty(phase) && !_.isEmpty(listingId)) {
          const redirectPath = `${pathPrefix}/${proposalType}/${PROPOSAL_PHASE_TYPE.COMPOSE}`
          const queryString = `listingId=${listingId}`
          res.redirect(`${redirectPath}?${queryString}`)
          return Promise.resolve()
        }

        // 修改賣場資訊欄位異常不打 API 預先處理直接導向錯誤畫面
        if (
          (phase === PROPOSAL_PHASE_TYPE.COMPOSE) &&
          // 沒有賣場編號
          _.isEmpty(listingId) &&
          // 沒有提案編號(compose + proposalId(id) 會導向檢視頁)
          _.isEmpty(targetId)
        ) {
          const errorCode = FE_ERROR_CODE.FE_LISTING_NOT_FOUND
          const tasks = [
            store.dispatch(setErrorBoundaryError({ code: errorCode, ids: [listingId] }))
          ]
          return Promise.all(tasks)
        }
      }

      const isCloneListing = feature === PROPOSAL_TYPE.CLONE_LISTING
      const isOverview = !_.isEmpty(targetId)
      if (isCloneListing && isOverview) {
        const redirectPath = `${pathPrefix}/${proposalType}/${PROPOSAL_PHASE_TYPE.OVERVIEW}`
        const queryString = `id=${targetId}`
        res.redirect(`${redirectPath}?${queryString}`)
        return Promise.resolve()
      }
    }

    // 如果是 clone 頁面，直接轉導至 compose 頁面，承續 compose 的流程
    // 並會在 client 濾掉 ID 及重置 reviewStatus
    if (phase === PROPOSAL_PHASE_TYPE.CLONE) {
      const cloneRedirectPath = `${pathPrefix}/${proposalType}/${PROPOSAL_PHASE_TYPE.COMPOSE}`
      const cloneQueryString = `${queryStringKey}=${targetId}&fromClone=true`
      res.redirect(`${cloneRedirectPath}?${cloneQueryString}`)
      return Promise.resolve()
    }

    const isInvalidUpdateFlow = (
      isUpdateSeries &&
      !(phase === PROPOSAL_PHASE_TYPE.OVERVIEW) &&
      !_.isEmpty(targetId) &&
      !(phase === PROPOSAL_PHASE_TYPE.PREVIEW)
    )
    if (isInvalidUpdateFlow) {
      const overviewRedirectPath = `${pathPrefix}/${proposalType}/${PROPOSAL_PHASE_TYPE.OVERVIEW}`
      const overviewQueryString = `${queryStringKey}=${targetId}`
      res.redirect(
        `${overviewRedirectPath}?${overviewQueryString}`
      )
      return Promise.resolve()
    }

    try {
      // 取得提案站別並查詢子站
      const subStationService = await store.dispatch(fetchProposalSubStations())
      const subStationIds = _.uniq(_.map(_.get(subStationService, 'payload', []), _.property('categoryId')))
      const tasks = [
        store.dispatch(fetchCategoriesBySubStations({ categoryId: subStationIds, proposalType }))
      ]
      if (compFetchData) {
        tasks.push(compFetchData({ store, req, res, match }))
      }
      return Promise.all(tasks)
    } catch (e) {
      throw e
    }
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Comp)
}
